<template>
  <div class="informations-wrapper">
    <div class="container">
      <div class="card card-form">
        <div class="card-section">
          <h3>Modifier vos informations personnelles</h3>
          <VForm :callback="() => {}">
            <template #form-body>
              <div class="input-inline">
                <VField
                  name="profil-firstname"
                  rules="required|textOnly"
                  v-model="user.first_name"
                  :label="$t('form.register.firstName')"
                  :disabled="true"
                />
                <VField
                  name="profil-lastname"
                  rules="required|textOnly"
                  v-model="user.last_name"
                  :label="$t('form.register.lastName')"
                  :disabled="true"
                />
              </div>
              <div class="input-inline">
                <div class="input-wrapper">
                  <label for="phone">{{ $t("form.register.phone") }}</label>
                  <vue-tel-input
                    id="phone"
                    v-model="user.phone_number"
                    :required="true"
                    :disabled="true"
                  >
                    <template v-slot:arrow-icon>
                      <i class="bi bi-chevron-down" />
                    </template>
                  </vue-tel-input>
                </div>
                <VField
                  type="email"
                  name="profil-mail"
                  rules="required|email"
                  v-model="user.email"
                  :label="$t('form.email')"
                  :disabled="true"
                />
              </div>
            </template>
          </VForm>
        </div>
        <div class="card-section">
          <h3>Modifier votre mot de passe</h3>
          <VForm
            :button="{
              label: 'Réinitialiser votre mot de passe',
              class: 'primary',
              hotDisabled: true,
            }"
            :callback="changeMyPassword"
            :clean="true"
          >
            <template #form-body="{ errors }">
              <VField
                type="password"
                placeholder="••••••••••••"
                name="profil-current-password"
                v-model="state.currentPassword"
                rules="required"
                icon="bi-lock"
                :label="$t('form.currentPassword')"
                :class="{
                  invalid: Object.keys(errors)[0] === 'profil-current-password',
                }"
              />
              <div class="input-inline">
                <VField
                  type="password"
                  placeholder="••••••••••••"
                  name="profil-new-password"
                  v-model="state.newPassword"
                  icon="bi-lock"
                  rules="required|password|is_not:@profil-current-password"
                  :helper="$t('form.register.must8char')"
                  :label="$t('form.newPassword')"
                  :class="{
                    invalid: Object.keys(errors)[0] === 'profil-new-password',
                  }"
                />
                <VField
                  type="password"
                  placeholder="••••••••••••"
                  name="profil-confirm-password"
                  v-model="state.confirmPassword"
                  icon="bi-lock"
                  rules="required|match:@profil-new-password"
                  :label="$t('form.confirmNewPassword')"
                  :class="{
                    invalid:
                      Object.keys(errors)[0] === 'profil-confirm-password',
                  }"
                />
              </div>
            </template>
          </VForm>
        </div>
      </div>
      <div class="side-col">
        <div class="card card-picture">
          <h3>Photo de profil</h3>
          <div class="header-block">
            <img
              class="picture"
              :src="
                user.image_id
                  ? getImage(user.image_id)
                  : getRandomUserPicture(user.first_name)
              "
              alt="picture"
            />
            <div class="block">
              <h4>Changer votre photo de profil</h4>
            </div>
          </div>
          <Dropload
            v-model="image"
            @update:modelValue="(event) => setImage(event)"
          />
        </div>
        <div class="card delete-account">
          <h3>Supprimer votre compte</h3>
          <p>
            Afin de supprimer votre compte veuillez contacter le
            <span class="virtual-link" @click="crisp.chat.open()"
              >service client</span
            >.
          </p>
          <p class="muted">
            La suppression de votre compte est définitive. Votre profil et
            l’ensemble de vos informations personnelles seront définitivement
            supprimés.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, inject } from "vue";
import { useUserStore } from "@/stores/user.js";
import { getImage, getRandomUserPicture } from "@/composables/getImage.js";
import { useImageStore } from "@/stores/image.js";
import { useCompanyStore } from "@/stores/company.js";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";

const toast = useToast();

const crisp = inject("crisp");

const { uploadImage } = useImageStore();

const { currentCompany } = useCompanyStore();

const { user, updateUserPicture, updatePassword } = useUserStore();

const image = ref(null);

const state = reactive({
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  loading: false,
});

async function setImage(value) {
  state.loading = true;

  const { image_id } = await uploadImage(
    currentCompany.company_id,
    "user_profile_picture",
    value
  );

  if (image_id) {
    user.image_id = image_id;

    await updateUserPicture(image_id);
  } else {
    toast.error("Une erreur est survenue lors du téléchargement de l'image");
  }

  state.loading = false;
}

async function changeMyPassword() {
  const resp = await updatePassword(state.currentPassword, state.newPassword);

  if (resp.code) {
    resp.key === "ERROR_AUTH_INVALID_CREDENTIALS"
      ? toast.error("Mot de passe actuel incorrect")
      : toast.error(getError(resp.key));
  } else {
    toast.success("Mot de passe modifié");
  }
}
</script>
